import { Pipe, PipeTransform } from "@angular/core";
import { StaffData } from "../../providers/staff";

@Pipe({
  name: "staff",
})
export class StaffPipe implements PipeTransform {
  constructor(private staffData: StaffData) { }

  public transform(idStaff: string, idClient: string) {
    return this.staffData.getEventStaff(idClient, idStaff);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/staff/staff.ts